import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../../../constants/dataAids';
import { OlsConfigStore, RouteHandler, ScrollWidgetActions } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';

import LabeledDropdown from './LabeledDropdown';

const { Block, Text } = UX2.Element;

const styles = {
  'display': 'flex',
  'justifyContent': 'center',
  'alignItems': 'center',
  'marginBottom': 'small',
  '@sm': {
    justifyContent: 'flex-end'
  }
};

const SortDropdown = props => {
  const {
    renderMode,
    translate,
    currentView,
    currentSortOption,
    products,
    fetching,
    selectedTaxonPermalink,
    routePath,
    searchKeywords,
    totalCount
  } = props;

  if (fetching || !products.length) return null;
  if (totalCount < 2) return null;

  const onSortDropdownChange = e => {
    RouteHandler.navigate(currentView, {
      sortOption: e.target.value,
      page: 1, // we always default to the first page when we change the sortOption
      routePath,
      keywords: searchKeywords,
      taxonPermalink: selectedTaxonPermalink
    });
    ScrollWidgetActions.scrollShopWidget();
  };

  const buildOptions = () => {
    const SORTING_KEYS = [
      'descend_by_popularity',
      'descend_by_created_at',
      'ascend_by_name',
      'descend_by_name',
      'ascend_by_price',
      'descend_by_price'
    ];

    if (searchKeywords && OlsConfigStore.getState().use_best_match) {
      SORTING_KEYS.unshift('descend_by_match');
    }

    return SORTING_KEYS.map((key, i) =>
      <option
        key={ `filter-option-${i}` }
        value={ key }
        children={ translate(`products.sort_options.${key}`) }
      />
    );
  };

  return (
    <Block id='filter-dropdown' style={ styles }>
      <Text
        children={ translate('products.sort_options.label') }
        style={{ marginRight: 'small', flexShrink: '0' }}
      />
      <LabeledDropdown
        data-aid={ dataAids.PRODUCT_SORT_DROPDOWN }
        labelColor='lowContrast'
        style={{ paddingRight: 'large' }}
        value={ currentSortOption }
        onChange={ onSortDropdownChange }
        inactive={ renderMode === 'EDIT' }
        children={ buildOptions() }
      />
    </Block>
  );
};

SortDropdown.propTypes = {
  renderMode: PropTypes.string,
  translate: PropTypes.func,
  currentView: PropTypes.any,
  currentSortOption: PropTypes.string,
  products: PropTypes.object,
  totalCount: PropTypes.number,
  fetching: PropTypes.bool,
  selectedTaxonPermalink: PropTypes.any,
  routePath: PropTypes.any,
  searchKeywords: PropTypes.any
};

export default SortDropdown;
